import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Георги Райчев",
    text: "Мястото е супер, намира се на по-главна улица и не трябва да се буташ по тесни улици. Обслужването е супер, хората си разбират работата. Много съм доволен, препоръчвам пред големите и скъпи сервизи!!",
  },
  {
    name: "Красимир Трайков",
    text: "Бързо, коректно, професионално и качествено обслужване. Препоръчвам на всеки, който има проблем с електроинсталацията на автомобила. Благодаря, че Ви има. С поздрав — Красимир Трайков, гр. Хасково",
  },
  {
    name: "Деян Делчев",
    text: "Страхотно обслужване, коректно, професионално, всичко е топ, с удоволствие ще го препоръчам на всеки. Живи и здрави и все така приветливи бъдете, много успехи за напред ви желая и много клиенти! Хубав и прекрасен ден, живи и здрави!",
  },
];

export default function Reviews() {
  return (
    <section id="reviews" className="border-t border-white/10 bg-[#0D0D0D] py-24 lg:py-32" data-testid="reviews-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <p className="mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.35em] text-[#39FF14]">
            <span className="font-display text-stroke-green text-3xl">03</span> Отзиви
          </p>
          <h2 className="font-display text-3xl font-extrabold uppercase tracking-tight sm:text-5xl">
            Какво казват <span className="text-[#39FF14]">клиентите</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <motion.blockquote
              key={r.name}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.14 }}
              className="group flex flex-col border border-white/10 border-l-2 border-l-[#39FF14] bg-[#0A0A0A] p-8 transition-colors duration-300 hover:border-white/20 hover:border-l-[#39FF14]"
            >
              <Quote size={28} className="mb-5 text-[#39FF14]/40 transition-colors duration-300 group-hover:text-[#39FF14]" />
              <p className="flex-1 text-sm leading-relaxed text-zinc-300">{r.text}</p>
              <footer className="mt-8 border-t border-white/10 pt-5">
                <div className="mb-2 flex gap-1" aria-label="5 от 5 звезди">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={14} className="fill-[#39FF14] text-[#39FF14]" />
                  ))}
                </div>
                <cite className="font-display text-sm font-bold uppercase tracking-wide not-italic text-white">
                  {r.name}
                </cite>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
